import {
  getGoogleMerchantSettingsEndpoints,
  IGetGoogleMerchantSettingsDTO,
  IGetGoogleMerchantSettingsResponse,
  IUpdateGoogleMerchantSettingsDTO,
  IUpdateGoogleMerchantSettingsResponse,
} from '@/models/googleMerchantSettings.model';
import { httpClient, ApiResponse } from '@/utils';

class GoogleMerchantSettingsAPI {
  static getMerchantSettings({
    channelId,
  }: IGetGoogleMerchantSettingsDTO): ApiResponse<IGetGoogleMerchantSettingsResponse> {
    const { GET_MERCHANT_SETTINGS } = getGoogleMerchantSettingsEndpoints({ channelId });
    return httpClient.get<IGetGoogleMerchantSettingsResponse>(GET_MERCHANT_SETTINGS);
  }

  static updateMerchantSettings({
    channelId,
    ...data
  }: IUpdateGoogleMerchantSettingsDTO): ApiResponse<IUpdateGoogleMerchantSettingsResponse> {
    const { UPDATE_MERCHANT_SETTINGS } = getGoogleMerchantSettingsEndpoints({ channelId });
    return httpClient.patch<IUpdateGoogleMerchantSettingsResponse>(UPDATE_MERCHANT_SETTINGS, data);
  }
}

export default GoogleMerchantSettingsAPI;
